import { render, staticRenderFns } from "./organization-unit-process-graph-view.vue?vue&type=template&id=dc926dbe&"
import script from "./organization-unit-process-graph-view.vue?vue&type=script&lang=js&"
export * from "./organization-unit-process-graph-view.vue?vue&type=script&lang=js&"
import style0 from "./organization-unit-process-graph-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports